import { createAction } from 'redux-act'
import { replace } from 'react-router-redux'
import API from 'api'

export const request = createAction('cellars/request')
export const receive = createAction('cellars/receive')
export const receivePaymentData = createAction('cellars/receivePaymentData')

import {
  updateCellarLanguages,
  updateCellarLanguage,
  updateEventLanguage,
} from 'actions/languages'

export const fetch = (id, locale) => (dispatch) => {
  dispatch(request({ id, locale }))
  dispatch(updateCellarLanguage(locale))

  // const { cellars } = getState();

  // if (cellars[id] && cellars[id][locale]) {
  //   const cellar = cellars[id][locale];
  //   dispatch(updateCellarLanguages(cellar.languages));
  //   return Promise.resolve(dispatch(receive({ id, locale, cellar })));
  // }

  return API.cellar(id, locale)
    .then(cellar => {
      dispatch(updateCellarLanguages(cellar.languages))
      dispatch(receive({ id, locale, cellar }))
      return Promise.resolve(cellar)
    })
}

export const getPaymentDataAction = (id) => (dispatch) => {
  return API.cellarPaymentData(id)
    .then(data => {
      dispatch(receivePaymentData({ id, data }))
      return Promise.resolve(data)
    })
}

export const redirectToUser = (hostname, lang) => (dispatch) => {
  return API.hostname(hostname)
    .then(cellar => {
      const { pathname } = window.location
      const addSlash = pathname[pathname.length - 1] !== '/' ? '/' : ''
      const url = `${window.location.pathname}${addSlash}${cellar._id}?lang=${lang}`
      dispatch(updateCellarLanguage(lang))
      dispatch(updateEventLanguage(lang))
      dispatch(replace(url))
    })
}
